import React from 'react';

import { Table} from 'semantic-ui-react'

import { AnalysisError} from '../../shared/interfaces'
import {useTranslation} from 'react-i18next'

interface IProps {
  detail:AnalysisError
}

export const ErrorDetailsRow = (
  { detail }:IProps
) =>{
  const { t } = useTranslation();
  return  <Table.Row>
    <Table.Cell>
      {t("errors.analysis." + detail.Category.toString())}
    </Table.Cell>
    <Table.Cell>
      {detail.Component}
    </Table.Cell>
    <Table.Cell>
      {detail.Detail}
    </Table.Cell>
    <Table.Cell>
      {detail.LineNo.toString()}
    </Table.Cell>
  </Table.Row>
}